import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { sortOrdersDataSource } from 'infrastructure/data-sources/sort-orders';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { ISortOrderItem } from 'infrastructure/data-sources/sort-orders';

type Options = IBaseSelectBoxOption<string, ISortOrderItem>[];

interface ISortOrderSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {
  ascLabel?: string;
  descLabel?: string;
}

const SortOrderSelectBox: React.FC<ISortOrderSelectBoxProps> = (props) => {
  const { ascLabel, descLabel } = props;

  const dataSource = useMemo(
    () => sortOrdersDataSource(ascLabel, descLabel),
    [ascLabel, descLabel],
  );

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default SortOrderSelectBox;
